import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const novemberMap: Array<IPixelMapDay> = [
	{
		status: "awful",
        icon: "shield_question",
		title: "No Title",
		reason: `
			A major fight broke out of nowhere.

			They didn't want to care about the problems I was going through. They tried their best to explain what they meant by that, but I was having none of it and asked them to apologize. They still didn't, and we both just ended with our stances unchanged. They suggested that I take my time to be okay and that I should contact them when I'm better, but I took it as something else. Why would a close "friend" leave me behind, to only talk to them when I'm okay, but when they're not okay, I'm *always* there for them, no matter what. It really irked me so I decided that I would just walk away and end this mess.
		`,
		spotify: {
			song: "Thinking Of You",
			artist: "Katy Perry",
			link: "https://open.spotify.com/track/4ciwlQ4UYHUMj2wuH0ffw6?si=06343ed74a884681",
			album: "One Of The Boys"
		},
        resonatedLyrics: [
            "Comparisons are easily done",
            "Once you've had a taste of perfection"
        ]
	},
	{
		status: "bad",
		reason: `
			We visited our dead relatives today and paid our respects.

			I still wasn't okay throughout most of the day. I was worried about it being the end of things. I was trying to convince myself that it was.
		`,
		spotify: {
			artist: "The Living Tombstone",
			song: "Five Nights at Freddy's",
			link: "https://open.spotify.com/track/5ZbwPEUqw1hK6rp0ppD8lR?si=29bb1cab8659415c",
			album: "Five Nights at Freddy's"
		},
        resonatedLyrics: [
            "We're waiting every night",
            "To finally roam and invite",
            "Newcomers to play with us",
            "For many years we've been all alone"
        ]
	},
	{
		status: "excellent",
		icon: "movie_edit",
		title: "Out in Makati",
		reason: `
			### Wow, was this day fun.

			It's been soooooooo long since I've spent a "normal" day outside. A day where I'm just focused on being with my friends with no other distractions. I didn't have to worry about anything else, my only agenda for today is to be with my friends, hang out, and just have fun. I spent the day with Max and Meryll again.

			I met with my friends at the Odd Cafe in Salcedo, Makati, and I have to say that our first stay there was pretty nice. We got to have a seat near the wall outlet and we were able to charge our devices. Since my friends knew my story, I had shared with them what I was going through and how painful the past few days have been for me. I'm glad they listened, then we moved on to talking about mundane stuff like which movies we should watch together, and how Marvel's new season of Loki was good.
			
			After that, we packed our stuff to eat at a store called Gino's Brick Oven Pizza nearby. I *missed* eating there, I swear. It's literally been years since we last ate at Gino's and it was really good. I missed the spicy honey and the pasta dishes we ordered we really good. When we all finished eating, we were so full! We walked around Salcedo Village to burn off what we ate and then went back to the Odd Cafe.

			When we got back, some of my friends had work to do since they weren't on leave for that day. We still talked, then had a spontaneous idea of watching Taylor Swift's Eras Tour movie again since the 2 of them haven't watched it. When I first watched it, I didn't really enjoy it because I *barely* sang any songs, even though I'm a big swiftie. We all agreed and then timed out, then headed to Glorietta mall by foot.

			To be honest, I deeply missed the feeling of walking around Makati's walkways and sidewalks in the afternoon. This area was the place where I had my first job and first company secondment. I deeply missed being here and I remembered how fun it was to be outside and being able walking around, after being stuck at home for so long. We got to the mall, ate some food, then had a really fun time watching the Eras Tour movie. I even had a hoarse voice at the end of it and got to sing all the songs I loved, especially Taylor's version of Long Live.

			Today was really, really fun and it reminded me of how fun working outside actually is. I get to be with friends, "work" alongside them, and even have spontaneous plans after work with them. I wish I could have more of these days in the future.
		`,
		spotify: {
			artist: "Taylor Swift",
			song: "Cruel Summer",
			link: "https://open.spotify.com/track/1BxfuPKGuaTgP7aM0Bbdwr?si=df3c333195554b3b",
			album: "Lover"
		},
	},
	{
		status: "bad",
		reason: `
			I just tried to lie in bed all day, sleeping it off, and feeling bad about things. Even though I was just with my friends yesterday, I still feel very lonely.
		`,
	},
	{
		status: "good",
		icon: "videogame_asset",
		title: "Friends Come Over!",
		reason: `
			Today actually got me nervous. I'm going to have friends come over to my house and they'll just hang out here. Having friends over isn't really a common thing for me, to be honest. I rarely have people come over my house and stay here.

			But Nate and his girlfriend Ane arrived here and they stayed for around 4 hours. We got to play Tekken and some games together. It was pretty fun, Nate got to beat me eventually once he started remembering the moves to Asuka's combos. I tried my best with my main girl Alisa, but sometimes he was just good at using Asuka. We had some conversations as well about the thing that's bothering me, and for what it's worth, it was nice having them be actually here, even though I'm doing so bad lately.

			Around the end of the day, we got to order take-out food from Jollibee and ate together while watching the Internet Historian. It was pretty fun and I appreciated them stopping by. The 4 hours they stayed barely felt like 30 mins and I wish I could have more friends drop by here.
		`,
		spotify: {
			artist: "Taylor Swift",
			song: "Now That We Don't Talk (Taylor's Version) (From The Vault)",
			link: "https://open.spotify.com/track/5QUIK7ZtziW8kGWo8RqopF?si=95358f6ad33c4aaf",
			album: "1989 (Taylor's Version) [Deluxe]"
		},
	},
	{
		status: "above-average",
		title: "A Continued Struggle",
		reason: `
			I knew this would happen. I expected it, but at the same time, I didn't think it would happen. It's been 5 days, we have never talked to each other for that long and I thought it was the end of things. I guess not, honestly.

			We got to talk and they reflected on some of their actions. They had their regrets and apologized for them. I told them that we still weren't okay until I've ranted to them, but I never did. I'm just gonna accept that things really are done in this way. It was awkward for us to talk again but we picked up where we had left off. Playing The Forest in our free time and I got to play Storyteller again. Things were suddenly okay, surprisingly, and I don't know if the past 5 days had any ramifications. But here things are.

			I did, however, tell them one, simple thing: no more "goodbyes" or "we're not friends anymore" and they agreed to it. Saying goodbye, hello over and over again has been so tiring for me and I really don't wanna bid goodbye to the friends I've cherished and shared so many memories with for almost 2 years now. I've decided long ago that I'm going to stay, no matter what, and I asked them to do the same. Here's to them not breaking that promise.
		`,
		spotify: {
			artist: "Natalie Holt",
			song: "Loki Green Theme",
			link: "https://open.spotify.com/track/5T7DUEeAj0hkMLTzIlDCRz?si=07faba156fec43e2",
			album: "Loki: Vol. 1 (Episodes 1-3) [Original Soundtrack]"
		},
	},
	{
		status: "good",
		title: "Long Call",
		icon: "phone_callback",
		reason: `
			I was in a surprisingly, long call with my friends. We talked for around 12 hours straight today, which kind of surprised me.

			In our free time, I got to watch them complete some parts of Storyteller and it was fun seeing and helping them complete the stories in the game. I also helped my friends install The Last of Us: Part I onto their PC and they played the first parts of the game. And later in the evening, we were still on call and they decided that we play some Taylor Swift "guess the song" and "continue the lyrics" games on YouTube. It was pretty fun for us to do since we're both Swifties, but they were a bigger Swiftie than I was. They won *all* of the games we played, only losing to me through some of the earlier songs in TS' discography.

			This day was really fun, and I can't believe how much stuff we did in the span of a single day.
		`,
		spotify: {
			artist: "Taylor Swift",
			song: "Now That We Don't Talk (Taylor's Version) (From The Vault)",
			link: "https://open.spotify.com/track/5QUIK7ZtziW8kGWo8RqopF?si=95358f6ad33c4aaf",
			album: "1989 (Taylor's Version) [Deluxe]"
		},
	},
	{
		status: "good",
		reason: `
			I got to watch *them* play The Last of Us: Part 1 on their PC again. It was good and surprised me how well the did in the "stealth" parts of the game.

			I got to talk to them about how they used to be interested in Five Nights at Freddy's and I was surprised, because I used to be info FNaF as well. They suggested that I should play the FNaF games again and I agreed. FNaF 1 was really scary, going back to it. It's been more than 5 years since I've last played a FNaF game so the first game really shocked me with all the jumpscares. We also decided to watch the Emma movie today since I didn't pay much attention to it when we first watched. It was good, and we decided to continue watching tomorrow.
		`,
		spotify: {
			artist: "Lecrae, Boi-1da",
			song: "Where We Come From",
			link: "https://open.spotify.com/track/2IjthaptX4H9KQwEj52Bqx?si=9ace609ace8b4a25",
			album: "Where We Come From"
		},
	},
	{
		status: "above-average",
		reason: `
			I finished watching Emma with my friends and it was a pretty good movie. Also, I got to present Taylor Swift's eras to my coworkers today. I was thinking whether or not I should include a controversial part in my original presentation, but I decided against it. Thankfully, it all worked out.

			Also I got my friends to watch me play the 1st Five Nights at Freddy's game and they saw me complete night 5.
		`,
		spotify: {
			artist: "Foster The People",
			song: "Pumped Up Kicks",
			link: "https://open.spotify.com/track/7w87IxuO7BDcJ3YUqCyMTT?si=385f0838cd4443e2",
			album: "Torches"
		},
	},
	{
		status: "above-average",
		reason: `
			My company had their Halloween/costume party today! 🎃 I finally got to use that Jollibee uniform and it was pretty fun to wear.

			Today was also the day that Aespa released their 4th mini album titled "Drama" and I got to wait for the release and watch it alongside my friends. Even though we didn't stream it in our Discord call, which saddened me a little bit, I still got to talk to them about it afterward. We both liked the new EP. In the background, I was trying to watch the season finale of season 2 of Loki. I really liked it and it was **perfect**, absolutely perfect.

			After work, I got to spend more time with my friends and I tried to help them troubleshoot their The Last Of Us: Part 1 installation. It was frustrating and we couldn't get it to work, so we just opted for other games to play. They also napped for a big portion of the evening and I had to wake them up for them to receive the fruit basket that I had to order for them.

			The rest of the evening was just me chilling and playing Dying Light 2 while trying to get my friends to watch my game stream.
		`,
		spotify: {
			artist: "aespa",
			song: "Drama",
			link: "https://open.spotify.com/track/5XWlyfo0kZ8LF7VSyfS4Ew?si=a5c67a6f55044656",
			album: "Drama - The 4th Mini Album"
		},
	},
	{
		status: "above-average",
		reason: `
			Today was a usual Saturday, I just stayed at home catching up on my missed mood calendar entries for the week and updating the codebases to my projects.

			In the afternoon, I talked myself into accepting opportunities that allow me to grow. I'm going to take future offers seriously and try them out if I get the chance. I really want to grow and my current position in life, and in work, doesn't allow me to grow further than where I am currently. It's time to change things up and I'm overdue for a fresh beginning.

			I also talked to some friends in the evening so that was good.
		`,
		spotify: {
			artist: "aespa",
			song: "Hot Air Balloon",
			link: "https://open.spotify.com/track/1mdtLny0zugh89vokWGG80?si=2bdb67d746f04761",
			album: "Drama - The 4th Mini Album"
		},
	},
	{
		status: "above-average",
		reason: `
			I mostly spent parts of the day by myself, watching videos on YouTube, listening to music, and I had enough of a decision to post something on my Instagram. I decided on posting my red pictures, in celebration of 2 years since the release date of Red (Taylor's Version).

			I got to play The Forest with my friends in the evening and we finished a good portion of it today. Shortly thereafter, I had some friends come over my house and spend some time here.
		`,
		spotify: {
			artist: "Taylor Swift",
			song: "The Lucky One (Taylor's Version)",
			link: "https://open.spotify.com/track/4e5ayHsOLJNLTGfjau2mEw?si=4ce8d2fbb5c943cf",
			album: "Red (Taylor's Version)"
		},
	},
	{
		status: "above-average",
		icon: "nature_people",
		reason: `
			I finished The Forest with my friends! It was pretty fun, we made our way to the boss' stage quickly even though we just planned on exploring some more. The game was so fun and it was pretty enjoyable, even though we all knew what the ending was.
		`,
		spotify: {
			artist: "Taylor Swift",
			song: "The Lucky One (Taylor's Version)",
			link: "https://open.spotify.com/track/4e5ayHsOLJNLTGfjau2mEw?si=4ce8d2fbb5c943cf",
			album: "Red (Taylor's Version)"
		},
	},
	{
		status: "above-average",
		reason: `
			Since it was salary day, I was able to buy UNCHARTED: Legacy of Thieves Collection with my friends on Steam! I got to play it and watch them play it, and I honestly get the appeal of the game. It was fun to use with my controller and I had fun playing it. I also ate Bonchon today, which was pretty nice, even though I feel like I overate again. Yeesh.
		`,
		spotify: {
			artist: "AJR",
			song: "Intertia",
			link: "https://open.spotify.com/track/2IA1ctUxjk865QW3CpIuZk?si=4238c3256aa542c4",
			album: "The Maybe Man"
		},
	},
	{
		status: "bad",
		reason: `
			I was having a "normal everything" today, initially. I even got to play Uncharted 4. Things were well, until the evening rolled around and the pain on my foot just got more and more extreme.

			I tried to sleep for an hour or so during 6-7 and when I woke up, my foot was searing in pain. I also got into a heated exchange.

			At the end, I wished and I prayed that I would get that plot twist. That one "photo opportunity" and a "shot at redemption." Surprisingly, I logged into a particular app on my phone and I met someone new.
		`,
		spotify: {
			artist: "LE SSERAFIM",
			song: "Perfect Night",
			link: "https://open.spotify.com/track/74X2u8JMVooG2QbjRxXwR8?si=28ad08132d544641",
			album: "Perfect Night"
		},
	},
	{
		status: "good",
		reason: `
			Yikes, this day just started off pretty bad.

			I was still unwell from yesterday and my mood hasn't gotten better, nor has my foot because I still can't walk. I hate this predicament. I tried to power through the day with me just working hard in the morning to finish one major project and deliverable for tomorrow.

			Thankfully, I got to play Uncharted 4 and my friends were able to watch my stream. In the afternoon, we joined call again so I could watch them play Uncharted: The Lost Legacy and they were able to finish it! It was fun to see them play it even though they were frustrated on some parts. In the background, I also was talking to someone on Telegram and they seemed pretty interested in me. She wanted to have pet names for each other and it was pretty cute, we exchanged some small pick-up lines and had fun talking. She also shared "Take A Chance With Me" by NIKI and an OPM song.
		`,
		spotify: {
			song: "Thinking Of You",
			artist: "Katy Perry",
			link: "https://open.spotify.com/track/4ciwlQ4UYHUMj2wuH0ffw6?si=06343ed74a884681",
			album: "One Of The Boys"
		},
	},
	{
		status: "above-average",
		reason: `
			Today was an awfully-quiet Friday. In the morning, I had a few meetings back to back and, thankfully, I didn't miss much from yesterday. I was even late for work this morning. In the morning, I had some spare time to watch the Miss Universe preliminaries.

			After that, I was pretty much left alone to continue working. I talked to someone during lunch time and it was still weird for me to be using a pet name, I was mostly getting used to it. But it felt nice to have to call someone that. I got back to work after lunch for a meeting and I slept through some parts of it. I had other tasks to deal with in the afternoon and I was able to recover from my mishap yesterday of deleting the files in my home folder in Linux.

			I got to call my friends in the early evening and we talked about a lot of serious topics, but joked around them. It was a pretty fun and light conversation, but something they said stuck to me:

			> Sige na, Dart. Find someone. Go, we support you.

			I haven't even told them that I'm talking to someone already. I've only talked and discussed this with my close friends and, while they support me on this 100%, I'm not going to call anything early. I think that's why Sour Grapes has been playing in my mind all day: the song is about that feeling.

			Whatever my choice may be, I'm putting my best foot forward in this. We even had a small argument because of a thing I really don't do with anyone, and I tried my best to communicate then apologize for taking part in the argument. It was a good test, so far.
		`,
		spotify: {
			song: "Sour Grapes",
			artist: "LE SSERAFIM",
			link: "https://open.spotify.com/track/6wBpO4Xc4YgShnENGSFA1M?si=935545a899834f75",
			album: "FEARLESS"
		},
		resonatedLyrics: [
			"푸릇 쌉싸름해 I don’t wanna taste",
			"뭐 그리 달콤하진 않을 것 같애",
			"설익은 감정들이 I just feel afraid",
			"I’ll never bite I’ll never bite the pain",
			"",
			"Sour 눈물 나게 시큼한 맛",
			"Sour 그런 게 만약 사랑이면",
			"맛보고 싶지 않아 I just feel afraid",
			"Love is sour, love is sour grapes"
		]
	},
	{
		status: "above-average",
		reason: `
			Most of my friends added me on Telegram today because I told them I have an account there again. And in the morning, I mostly slept until noon. When I woke up, I talked to someone on Telegram and we had a fun talk for 2 hours before they had to go do their thing. I was still mostly sleepy so I just slept for more time.

			Around the afternoon, Nate and Ane told me that they were both coming over to my house. I completely forgot that they had made plans to come over here from last week's visit. They brought a laptop with them so they could play Valorant. In the beginning of their stay, we watched the Five Nights at Freddy's movie. It was pretty fun to watch and I was able to get back into the lore since I've been trying to re-play the games in my downtime. Nate kept talking so much throughout the movie! It was annoying but he was kinda funny as well.

			While we were eating, Nate asked to borrow my phone and I told them about this new person I'm talking to. They were hesitant but I told them that this new person was nice. I guess they can understand since they themselves met through a dating app this year. They also used my phone to text other things to the girl and God knows what.

			Ane and Nate played Valorant on my PC and the laptop they brought, they won for the 2 games they played while I just watched and took pics of them. At the end, we had a cute discussion and they were able to walk me through some of the feelings I've been having, of the girl and other things. They seemed on board at the end and showed support. I'm happy to have friends who stand by.

			I'm happy, honestly. I've lost a lot of friends over the past 2 years. To the point where I have an entirely new set of friends these days. But I'm glad, I still have people supporting me and they have my back. I've lost a lot of friends but I've also gained unlikely ones.
		`,
		spotify: {
			song: "All This Time",
			artist: "Tiffany",
			link: "https://open.spotify.com/track/5jzDnEoTtwzvJfvVx52rDC?si=ffdd968c7b4f4311",
			album: "Hold An Old Friend's Hand"
		},
	},
	{
		status: "awful",
		title: "Hit after Hit",
		icon: "sports_mma",
		reason: `
			Jesus Christ, was today depressingly hard to get through.

			I couldn't sleep and I stayed up until 5 a.m. in the morning thinking of a lot of things. I was thinking of everything: how to proceed with that new person on Telegram, what to do when they respond, where am I going in life, should I dedicate myself further to this or not, and a lot more.

			Ultimately, I made a decision, if they're going to treat me with respect and they're nice, accommodating, and see me as an equal, I would be welcoming to them and still be onboard. If not, I'll just decide to end this while it's early.

			So I got to talk to them after I woke up. It made for a really tense morning. They showed their side and I understood where they were coming from. But I was met with really harsh responses. I tried asking them nicely but I'm met with a lot of attitude and disrespect. They said sorry, apologized, but I knew that this is not how I want my future partner to treat me. It would've been nice if they promised that they would do better, or made it up to me, instead of just saying sorry and saying that's how they are. I'm so sick of being disrespected by people who I want to see as my equal. It's like I'm constantly pushed down and spat and stepped on.

			I was disappointed that things had to go to this chain of events, but I knew what had to be done: I had to cut this off. They quickly agreed and it was left at that.

			Sometime later in the afternoon, I was heartbroken and I was just so, so fed up.

			I am so sick and tired of me going into these "new experiences with the promise of something more" only for it to blow up in my face a few days or some time later. My wishes coming true but they're straight out of a monkey's paw: *always* coming with a horrible twist. Even though I come into things with the best of intentions, with high hopes, even with my best foot forward, I always lose. L after L and hit after hit. I am trying my best, screaming at the damn opportunity to make my life better and I get fucking spat on the face.

			I literally just want to be happy. To go outside, have fun on dates, and experience new things together. I deserve to be happy in my own story. But I feel like I lost.

			So I did what I do best: internalize my pain. Direct it on me. It's *my* fault. *I* don't deserve a happy life. These horrible experiences are what *I* deserve and the current me will always get these experiences until I do something about it.

			> In every moment, there is the possibility of a better future. But you people won't believe it, and because you won't believe it, you wouldn't do what is necessary to make it a reality. So you dwell on this terrible future, and you resign yourself to it.<br /><br />For one reason: Because that future doesn't ask for anything from you, today.

			That's it. I'm tired of crying. I'm tired of my circumstances and outcomes being the same. I'm going to improve my life no matter what. And get the happy life I deserve, no matter what. I'm going to do my best so that my future self can be happy.
		`,
		spotify: {
			song: "History Is Now",
			artist: "Natalie Holt",
			link: "https://open.spotify.com/track/6xhX358ASr7E5xlTdPUeSH?si=c5657384746e46dd",
			album: "Loki: Season 2 - Vol. 2 (Episodes 4-6)[Original Soundtrack]"
		},
	},
	{
		status: "above-average",
		reason: `
			Not much happened today, just your usual stuff at work. Things continued as usual, meetings.
			
			In the evening, I just watched my friends play Sims 4 on stream and, after we all left the call, I was alone with my thoughts. I really thought to myself that I need to change things. I need to make the tough decisions in order to get that big chair. After giving myself pep talk for the night and planning out how I'll steer myself next month, I knew what I had to do.
		`,
		spotify: {
			song: "History Is Now",
			artist: "Natalie Holt",
			link: "https://open.spotify.com/track/6xhX358ASr7E5xlTdPUeSH?si=c5657384746e46dd",
			album: "Loki: Season 2 - Vol. 2 (Episodes 4-6)[Original Soundtrack]"
		},
	},
	{
		status: "above-average",
		reason: `
			I migrated my main website and portfolio to AWS Amplify! It was a pain setting it up because I had SSL features fail again and again, but it finally worked! I was able to deploy a few builds and it was just fun to migrate everything.

			In the evening, I chilled and watched my friends play Sims 4. We watched some scary videos afterward.
		`,
		spotify: {
			song: "Tataya",
			artist: "Cup of Joe",
			link: "https://open.spotify.com/track/6xlUGjSVu90hOMa8cxXCRh?si=d4831fe3eb72483a",
			album: "Tataya"
		},
	},
	{
		status: "above-average",
		reason: `
			I couldn't call my friends that much today because they had no Internet connection and had to use data. So I spent most of the day and evening alone, just applying for jobs. Today was pretty quiet, ngl. I feel like I could get used to more days like this.
		`,
		spotify: {
			artist: "NewJeans",
			album: "NewJeans 2nd EP 'Get Up'",
			song: "ETA",
			link: "https://open.spotify.com/track/56v8WEnGzLByGsDAXDiv4d?si=75c032dab7554443"
		},
	},
	{
		status: "above-average",
		title: "Nicknames",
		reason: `
			Someone shared to me a video that had See Tinh and then that song was stuck in my head for the entire day!

			Nothing much happened aside from your usual workweek. I did watch aespa's "Who visit [sic] the VILLA?" during lunch break with someone and it was so cute and also interesting. I felt kinda sad when Winter had a tear roll down her cheek.

			Today, I re-migrated my portfolio and website back to Vercel because AWS Amplify turned crazy expensive after a day's worth of operation.

			In the evening, someone invited me to play Lethal Company with my friends. I bought it and played it with them. It was pretty fun and unique to play. We also played The Forest afterwards and I felt nostalgic over the bare area that my friends and I built our base upon.
		`,
		spotify: {
			artist: "Hoàng Thùy Linh",
			album: "See Tình (Speed Up Version)",
			song: "See Tình (Speed Up Version)",
			link: "https://open.spotify.com/track/5sCATdnR2mWbHgdmIXBFHa?si=9d6f9fd1fbdd44d8"
		}
	},
	{
		status: "good",
		reason: `
			Today is finally Fridayyyy! There's a long weekend ahead so I can breathe for the next few days. Unfortunately, not with a comfortable feeling because I am way down on my cash reserves. So unless I turn to e-begging, I have to scrape by until next week.

			Nevertheless, I was able to complete big things in the background today. In the morning, I was able to deploy that DevOps assessment to my domain and Linux server. It was pretty fun to deploy and sort of rekindled my server admin skills. I also continued with work today and was able to finish big tasks.

			In the evening, I got to play Lethal Company again with my friends. It was pretty fun, we got to complete a lot of levels. After taking a short break from playing, I got back into a call with my friends again and we played Stardew until the morning, then watched scary videos.

			Also, I was able to deploy [notes.dartegnian.com](https://notes.dartegnian.com) and I'm going to put my future notes there.
		`,
		spotify: {
			song: "Permission to Dance",
			artist: "BTS",
			link: "https://open.spotify.com/track/3XYRV7ZSHqIRDG87DKTtry?si=983f4272cd5f4e8d",
			album: "Permission to Dance"
		},
	},
	{
		status: "above-average",
		reason: `
			I woke up from a weird dream about going to the mall with someone, losing them, and then getting trapped in an escape room in Japan.

			Today, I was mostly busy today fixing my server. It was *very* stressful, to be honest. I was so close to pulling out my hair from the stress. Nate and Ane wanted to come over today, but I couldn't accommodate them because I was too busy fixing the CPU usage on my server. It sucked that I couldn't invite them, nor did I have money to order take out alongside them either.
			
			I finished around very late in the evening because I had to clean my keyboard for an hour. Cleaning my keyboard was the most chill part of the day. It deserved a well-needed clean and just cleaning it—not being overstimulated from anything—was pretty fun. I could get used to this.

			After all that was said and done, my server and sites are completely up-to-date and everything's looking pretty good.
		`,
		spotify: {
			song: "Lovefool",
			artist: "The Cardigans",
			link: "https://open.spotify.com/track/7aQjPecQdIuNd1sz3KCDhD?si=957853c2f8d742ef",
			album: "First Band On The Moon (Remastered)"
		},
		resonatedLyrics: [
			"Dear, I fear we're facing a problem",
			"You love me no longer, I know and",
			"Maybe there is nothing that I can do",
			"To make you do"
		]
	},
	{
		status: "above-average",
		reason: `
			I got to finish the initial version of my DDLC easter egg to this website! Saturday to Sunday morning was such a sleepless stretch. I couldn't even sleep properly, I don't know why.

			So I woke up late, probably 1 or so and I feel like I had a weird dream but I forgot. Anyway, not much happened in the afternoon. In the evening, I got to play Lethal Company with my friends and Luan, we had a lot of rounds and I think it's a pretty fun game.

			When we finished playing, my friends and I decided to watch A Haunting in Venice (2023) and it was pretty good. I expected it to be a horror movie, like one with ghosts and spooky stuff, but no, it was a thriller—a murder mystery, to be exact. It was good but wasn't what I expected.

			I wasn't sleepy, and the argument really drained me, so I decided to watch Bedtime Stories (2008) and then slept after watching a good bit.
		`,
		spotify: {
			song: "Doki Doki Literature Club!",
			artist: "Dan Salvato",
			link: "https://open.spotify.com/track/2OSFhiIBYXIBiVOyLnDQ2b?si=bede9976ae084efe",
			album: "Doki Doki Literature Club! (Original Soundtrack)"
		},
	},
	{
		status: "below-average",
		reason: `
			I decided to watch Bedtime Stories (2008) so that I'll have some imagination and inspiration again. I seriously love this movie, this is definitely my 2nd or 3rd favorite movie of all time. I also decided to watch a good chunk of Hall Pass (2011). Those were movies I watched while growing up and they helped me feel better, even though I was trying so hard to keep it together.

			I did some small DevOps learning so that I could be better in my future jobs. I took notes on my newly-deployed notes app/website and it was actually pretty fun to use, ngl.

			After taking notes, calming down by finishing Bedtime Stories, I got to talk to my friends again. They opened up something, I offered that we play Stardew Valley but we didn't really talk it out over the game. Only after the game we had a discussion about it. Then we had a mutual agreement in the end, that was that. The night continued as usual.
		`,
		spotify: {
			song: "Psychic City - Classixx Remix",
			artist: "YACHT",
			link: "https://open.spotify.com/track/4ksBDCHoDChFW83N2xUBBu?si=dbd52320bf994041",
			album: "Psychic City"
		},
	},
	{
		status: "above-average",
		reason: `
			I slept on time but surprisingly woke up an hour later than my usual time in. Someone tried to wake me up, and even call me, so that I can get up for work. I appreciate their efforts, but I sadly didn't wake up from them, still, haha.

			Work was a lot today. It was very tiring and draining. I'm really starting to wonder if I'm burned out, like, **really** burned out. I personally think I'm burned out. With how 2023 has been, I kind of feel like I just want a really long rest. A breather from things. Unfortunately, I could only dream of those as I attended meetings and I was faced with something that rocked me to the core.

			I personally felt weak. I was able to compose myself for a bit afterward.

			In the evening, I played several rounds of Lethal Company with my friends and Luan again. We played Phasmophobia again shortly after. It was fun, but I guess Phasmo wasn't as scary anymore since I wasn't that afraid. After playing for a few rounds and winning, the evening still had me worried about a lot of things. I paced back and forth, giving myself a pep talk because I was so close to being emotionally on the edge. After calming myself down, I got to work on my problem and fixed 2 of them. So that was nice. I'm still shaken, but thankfully not stirred anymore.
		`,
		spotify: {
			song: "Closer",
			artist: "The Chainsmokers, Halsey",
			link: "https://open.spotify.com/track/7BKLCZ1jbUBVqRi2FVlTVw?si=157d684743b74a60",
			album: "Closer"
		},
		resonatedLyrics: [
			"Hey, I was doing just fine before I met you",
			"I drink too much and that's an issue, but I'm okay"
		]
	},
	{
		status: "above-average",
		reason: `
			Nothing much happened today, everything was fairly routine. I did have an issue with my bank in the afternoon. (And it still isn't resolved by the time of writing, they have a bad DevOps handling them.) But other than that, my day was as usual as it was: fun, games, music.

			I spent most of the day with my friends and it was fun to watch them play Sims 4 after work. I also got to play Stardew Valley with them for a bit, then Lethal Company with Luan tagging along. We had good runs, I know we got good at the game because we aren't as scared and we didn't die that much today.

			Today was also the day Spotify Wrapped got released. It's not much from what I can see on my Last.fm profile, but it was still fun to look at.
		`,
		spotify: {
			song: "California Gurls",
			artist: "Katy Perry",
			link: "https://open.spotify.com/track/1GhbQDYGEOjyFwfT8lojcx?si=694670e756dd416d",
			album: "Teenage Dream"
		},
	},
	{
		status: "above-average",
		reason: `
			Today was a usual day for me, I got into a call with friends but we didn't stay together for that long in the evening. I mostly recall feeling very sleepy today, but nothing much was that different.
		`,
		spotify: {
			song: "Di Bale Na Lang",
			artist: "Gary Valenciano",
			link: "https://open.spotify.com/track/5WgmB8En0PJs5lM8Icv8Qu?si=2eb80a1b87e24daa",
			album: "At The Movies"
		},
	},
];

export default novemberMap;
